import { PrimaryDialog, Typography } from "@foodpilot/foods";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useTrajectoryForm } from "./TrajectoryInitForm/useTrajectoryForm";
import { ElligibleStartingPost } from "src/context/Actions/context";
import { Score } from "src/types";
import { OneActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useGetOneActionPlan";
import { TrajectoryInitForm } from "./TrajectoryInitForm/TrajectoryInitForm";
import { ActionPlanWrite } from "src/api/client-api/ActionPlan/ActionPlan/useUpsertActionPlan";

type TrajectoryCreationModalProps = {
    createActionPlan: (data: ActionPlanWrite) => void;

    isOpen: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;

    elligibleStartingPosts: ElligibleStartingPost[] | undefined;
    scoresEnabled: Score[];
    actionPlan: OneActionPlan | null;
};
export const TrajectoryCreationModal = (props: TrajectoryCreationModalProps) => {
    const { t } = useTranslation();
    const { createActionPlan, isOpen, setOpen, elligibleStartingPosts = [], scoresEnabled, actionPlan } = props;

    const formHandler = useTrajectoryForm({
        actionPlan,
        scoresEnabled,
        elligibleStartingPosts,
    });
    if (formHandler === undefined) return;

    const { formState, setFormState, formSubmit, remainingScoreOptions, allScoreOptions } = formHandler;

    return (
        <PrimaryDialog
            open={isOpen}
            setOpen={setOpen}
            onValidate={() => {
                const data = formSubmit();

                if (data === null) return;
                createActionPlan(data);
            }}
            onCancel={() => {}}
            options={{
                title: <Typography variant="h4">{t("actionPlan.trajectory.form.title")}</Typography>,
                content: (
                    <TrajectoryInitForm
                        form={formState}
                        setForm={setFormState}
                        remainingScoreOptions={remainingScoreOptions}
                        elligibleStartingPosts={elligibleStartingPosts}
                        allScoreOptions={allScoreOptions}
                    />
                ),
            }}
            cancelText={t("primaryDialog.cancel")}
            validateText={t("primaryDialog.validate")}
        />
    );
};
